// @flow
import RequestsData, { type RequestsDataProps } from './RequestsData';
import useRequestsData, { useGenertalSettings } from './useRequestsData';
import type { RoleType, PeriodType } from './types';

export default RequestsData;
export { useRequestsData, useGenertalSettings };
export type { RequestsDataProps, RoleType, PeriodType };
